import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-36-nilesh-bajaj-guest.webp";
import ThumbImg from "../../assets/images/conversations/036.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: vv-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .vv-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .vv-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .vv-hero { padding-top: 60px; padding-bottom: 60px; }
  .vv-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .vv-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .vv-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vv-hero__title.vv-visible { opacity: 1; transform: translateY(0); }
  .vv-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .vv-hero__spotify.vv-visible { opacity: 1; transform: translateY(0); }
  .vv-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .vv-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .vv-hero__right.vv-visible { opacity: 1; transform: translateY(0); }

  .vv-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .vv-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .vv-yt-thumb:hover img { opacity: 0.85; }
  .vv-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .vv-yt-thumb__play img { width: 40px; height: 44px; }
  .vv-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .vv-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .vv-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vv-body.vv-visible { opacity: 1; transform: translateY(0); }
  .vv-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .vv-body__para:last-child { margin-bottom: 0; }

  .vv-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vv-guest.vv-visible { opacity: 1; transform: translateY(0); }
  .vv-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .vv-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .vv-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .vv-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .vv-inner { padding-left: 32px; padding-right: 32px; }
    .vv-hero { padding-top: 32px; padding-bottom: 48px; }
    .vv-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .vv-hero__title { font-size: 24px; }
    .vv-hero__left { gap: 16px; }
    .vv-guest__title { font-size: 24px; margin-bottom: 24px; }
    .vv-guest__photo-bg { width: 260px; height: 300px; }
    .vv-guest__name { font-size: 24px; margin-top: 18px; }
    .vv-body__para { font-size: 14px; margin-bottom: 12px; }
    .vv-body { padding-bottom: 48px; }
    .vv-guest { padding-bottom: 48px; }
    .vv-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .vv-inner { padding-left: 16px; padding-right: 16px; }
    .vv-hero { padding-top: 51px; padding-bottom: 30px; }
    .vv-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .vv-hero__left { gap: 30px; }
    .vv-hero__title { font-size: 30px; }
    .vv-body__para { font-size: 16px; margin-bottom: 10px; }
    .vv-guest__title { font-size: 30px; margin-bottom: 20px; }
    .vv-guest__photo-bg { width: 100%; height: 386px; }
    .vv-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .vv-body { padding-bottom: 30px; }
    .vv-guest { padding-bottom: 30px; }
    .vv-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("vv-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP36_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="vv-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 36 Vayve Mobility"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="vv-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 36 Vayve Mobility thumbnail" />
      <div className="vv-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="vv-hero">
      <div className="vv-inner">
        <div className="vv-hero__grid">
          <div className="vv-hero__left">
            <h1 ref={titleRef} className="vv-hero__title">
              EP 36 | Decoding Solar-Powered Urban Mobility | Vayve Mobility
            </h1>
            <div ref={spotifyRef} className="vv-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/7aDpWpXG08LETPckXaClI0?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 36 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="vv-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vv-body">
      <div className="vv-inner">
        <p className="vv-body__para">
          How often in your life do you get to meet someone who wants to design and launch a new car, an actual car? For many kids, particularly boys, the first ever drawing they make is often a car. But very few grow up with that dream to challenge an established industry that is over 100 years old and is dominated by giants. Today, we speak to someone who is actually doing that — designing and launching an electric car specifically for urban mobility in India. We speak with Nilesh Bajaj, co-founder &amp; CEO at Vayve Mobility.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vv-guest">
      <div className="vv-inner">
        <h2 className="vv-guest__title">Our Guest</h2>
        <div>
          <div className="vv-guest__photo-bg">
            <img src={GuestImg} alt="Nilesh Bajaj" />
          </div>
          <p className="vv-guest__name">Nilesh Bajaj</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep36VayveMobility() {
  return (
    <>
      <style>{CSS}</style>
      <div className="vv-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}